import React, { useContext } from "react";
import classNames from "classnames";

import { OfferStoreContext } from "@gp/components";

import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { BetBuilderActionsTypeEnum } from "@data-types/analytics-tracker/BetBuilderInteractionTypeEnum";
import { analyticsTracker } from "@utils/analytics";
import {
	UseCenteredSwiperSlideArgs,
	useCenteredSwiperSlide,
} from "@components-shared/desktop/centered-swiper";

export type BettingTypeHeaderBettingGroupsButtonInfo = {
	abrv: string;
	name: string;
};

export function BettingTypeHeaderBettingGroupsButton({
	bettingTypeGroup,
	isActive,
	index,
}: {
	bettingTypeGroup: BettingTypeHeaderBettingGroupsButtonInfo;
} & UseCenteredSwiperSlideArgs) {
	const offerStore = useContext(OfferStoreContext) as
		| EventViewStore
		| AdditionalOfferViewStore;

	useCenteredSwiperSlide({ isActive, index });

	const isBetBuilder = bettingTypeGroup.abrv === "bet-builder";

	return (
		<button
			className={classNames(
				"tabs__item tabs--boxed__item tabs--scroll__item",
				{
					"is-active": isActive,
					// "tabs--boxed__bb": isBetBuilder,
				}
			)}
			onClick={() => {
				offerStore.setDisplayBettingGroup(bettingTypeGroup.abrv);

				if (isBetBuilder) {
					analyticsTracker.trackBetBuilderInteraction(
						BetBuilderActionsTypeEnum.BBTabOpen
					);
					offerStore.setBBParms("true");
				} else {
					offerStore.setBBParms("");
				}
			}}
			type="button"
		>
			{isBetBuilder && (
				<i className="tabs__frame tabs--boxed__frame u-icon u-icon--sml u-icon--bb--active" />
			)}
			<span className="tabs__title tabs--boxed__title">
				{bettingTypeGroup.name}
			</span>
		</button>
	);
}
